import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MembershipControlComponent } from "./membership-control.component";
import { MembershipControlModalComponent } from "./membership-control-modal.component";
import { IonicModule } from "ionic-angular";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        MembershipControlComponent,
        MembershipControlModalComponent
    ],
    exports: [
        MembershipControlComponent
    ],
    entryComponents: [
        MembershipControlModalComponent
    ]
})
export class MembershipControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/membership/form/membership-control.module.ts